import get from 'lodash/get';
import { createSelector } from 'reselect';
import { WidgetState } from './types';

export const widget = (state: { widgets: WidgetState }): WidgetState => state.widgets;

export const getWidgetData = createSelector([widget], (widgetData) =>
  get(widgetData, 'widgetData', {})
);

export const getSimilarData = createSelector([widget], (widgetData) => {
  const relatedProducts = get(widgetData, `widgetData.relatedProducts`, []);
  const productList = relatedProducts.find((widgets) => widgets.widget_type === 'similar_products');
  return productList || {};
});

export const widgetError = createSelector([widget], (widgetData) => widgetData.isFetchingError);

export const getProductIDFromWidgetStore = createSelector([widget], (widgetData) =>
  get(widgetData, 'productID', '')
);

export const isWidgetFetching = createSelector([widget], (widgetData) => widgetData.isFetching);
export const isWidgetFetchStarted = createSelector([widget], (widgetData) => widgetData.isStarted);
